import {
  GET_SURGE_TEMPLATE_VERSION,
  GET_SURGE_TEMPLATE_VERSION_SUCCESS,
  GET_SURGE_TEMPLATE_VERSION_ERROR,
  GET_SURGE_TEMPLATE_VERSION_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetSurgeTemplateVerison = (state = initialState, action) => {
  switch (action.type) {
    case GET_SURGE_TEMPLATE_VERSION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_TEMPLATE_VERSION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_SURGE_TEMPLATE_VERSION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_SURGE_TEMPLATE_VERSION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetSurgeTemplateVerison;
